// ─── Fase 19 · Descuentos (verano + referidos) ───────────────────────────────
// Fuente única del front. Debe ir en sincronía con Stripe/Railway:
//  · verano  → variable STRIPE_COUPON_SUMMER (cupón −30%)
//  · referido→ Promotion Code en Stripe con el nombre del código (p. ej. CARLOS)
// El precio mostrado usa el % de aquí; el cobro real siempre lo decide Stripe.
import { getRef } from "./referral";

export const SUMMER = { active: true, pct: 30 };

// Código de referido (en minúsculas) → % de descuento. Añade uno por afiliado,
// con el mismo % que su cupón de Stripe.
export const REFERRALS = { "crt-26": 40 };

// Descuento efectivo. Prioridad: referido > verano > ninguno.
export function getDiscount() {
  const ref = (getRef() || "").toLowerCase();
  if (ref && REFERRALS[ref] != null) return { active: true, pct: REFERRALS[ref], kind: "ref", code: ref };
  if (SUMMER.active) return { active: true, pct: SUMMER.pct, kind: "summer", code: null };
  return { active: false, pct: 0, kind: null, code: null };
}

export const BASE_PRICE = { pro: 31, annual: 199 };

const fmt = (v, locale) =>
  v.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function discountedPrice(base, locale = "es-ES") {
  return fmt(base * (1 - getDiscount().pct / 100), locale);
}
export function savedAmount(base, locale = "es-ES") {
  return fmt(base * (getDiscount().pct / 100), locale);
}
